import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("offer-section", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("offer-section")
      ) {
        return {
          type: "offer-section",
        };
      }

      return false;
    },
    model: {
      defaults: {
        draggable: true,
        droppable: false,
        components: html`
          <section class="container mx-auto  md:px-12  px-4  ">
            <div class="mt-5 p-5 ">
              <div class="flex items-center leading-2.5 gap-1 my-2">
                <div class="bg-amber-600 w-1 md:h-12 h-6 inline-block"></div>
                <h3
                  class="md:text-4xl text-lg font-bold font-roboto tracking-normal text-[#0083D7]"
                >
                  What we Offer
                </h3>
              </div>
              <div
                class="md:grid md:grid-cols-2 md:gap-5 md:space-y-0  space-y-4 mb-6 w-full mt-10 text-[#0083D7]  "
              >
                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class=" text-lg md:text-2xl font-semibold w-full font-roboto tracking-wide  "
                  >
                    Worldwide network in almost airlines
                  </p>
                </div>

                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class="text-lg md:text-2xl font-semibold w-full font-roboto  tracking-wide  "
                  >
                    Authorized Agent Top Couriers Like FEDEX, DHL, TNT, UPS,
                    SKYNET and Many More
                  </p>
                </div>

                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class="text-lg md:text-2xl font-semibold w-full font-roboto tracking-wide  "
                  >
                    Doorstop Goods Collection
                  </p>
                </div>

                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class="text-lg md:text-2xl font-semibold w-full font-roboto  tracking-wide  "
                  >
                    Packaging Aany Types Of Goods
                  </p>
                </div>

                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class="text-lg md:text-2xl font-semibold w-full font-roboto  tracking-wide  "
                  >
                    Digital documentations for Customs Cleareance
                  </p>
                </div>

                <div
                  class="  gap-6  rounded-lg p-6 md:p-10 flex items-center justify-center shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
                >
                  <p
                    class="text-lg md:text-2xl font-semibold w-full font-roboto  tracking-wide  "
                  >
                    Safe and Secure Warehouse For Storage of Goods
                  </p>
                </div>
              </div>
            </div>
          </section>
        `,
        script: function () {
          // const initLib = function () {
          //   //@ts-ignore
          //   AOS.init();
          // };
          // //@ts-ignore
          // if (typeof AOS === "undefined") {
          //   const script = document.createElement("script");
          //   script.onload = initLib;
          //   script.src = "https://unpkg.com/aos@2.3.1/dist/aos.js";
          //   document.body.appendChild(script);
          // } else {
          //   initLib();
          // }
        },
      },
    },
  });
};
